import createReactComponent from '../createReactComponent';
var Loader2 = createReactComponent('Loader2', [['path', {
  d: 'M21 12a9 9 0 1 1-6.219-8.56',
  key: '13zald'
}]]);
export default Loader2;